export default __webpack_public_path__ + "static/media/createTask.1ea8f30f.png";